export const translations = {
    en: {
        dashboard: "Dashboard",
        classroom: "Classes",
        takeTest: "Take Quiz",
        myResults: "My Results",
        logout: "Logout",
        hello: "Hello",
        user: "User",
        classroomDescription: "Access your classes and course materials",
        testDescription: "Take quizzes and assessments",
        resultsDescription: "View your test results and performance",
        confirmLogout: "Are you sure you want to logout?",
        logoutMessage: "You are about to log out of your account. Any unsaved changes will be lost.",
        cancel: "Cancel",
        classDetails: "Class Details",
        aboutThisClass: "About this Class",
        noDescription: "No description available for this class.",
        created: "Created on:",
        availableResources: "Available Resources",
        noResources: "No resources yet",
        noResourcesDescription: "There are no resources available for this class yet.",
        continueQuiz: "Continue Quiz",
        takeQuiz: "Take Quiz",
        viewResults: "View Results",
        viewCourse: "View Course",
        completed: "Completed",
        inProgress: "In Progress",
        pendingEvaluation: "Pending Evaluation",
        notStarted: "Not Started",
        errorLoading: "Loading error:",
        errorLoadingDescription: "We couldn't load the class details. Please try again later.",
        backToClasses: "Back to Classes",
        myClasses: "My Classes",
        calendar: "Calendar",
        courses: "Courses",
        exam: "Exam",
        eventsFor: "Events for",
        noEvents: "No events for this date",
        yourClasses: "Your Classes",
        joinClass: "Join class",
        joinClassTitle: "Join class",
        joinCodePrompt: "Enter class code",
        joinCodeLabel: "Class code",
        noMatchingClasses: "No matching classes found",
        noMatchingClassesDesc: "Try modifying your search term or join a new class.",
        noClassesAvailable: "No classes yet",
        noClassesAvailableDesc: "Join a class to get started.",
        joinSuccess: "Class joined successfully!",
        joinError: "Unable to join class",
        searchPlaceholder: "Search classes...",
        yourQuizResults: "Your quiz results",
        noDescriptionGeneric: "No description available",
        scoreLabel: "Score:",
        viewDetails: "Details",
        noMatchingResults: "No matching results found",
        noMatchingResultsDesc: "Try modifying your search term or take a quiz to see results here.",
        noQuizResultsAvailable: "No quiz results available",
        noQuizResultsAvailableDesc: "Take a quiz to start seeing your results here.",
        quizResults: "Quiz results",
        back: "Back",
        errorLoadingQuiz: "Error loading quiz details",
        goBack: "Back",
        quizInformation: "Quiz details",
        timeLimit: "Time limit:",
        minutes: "min",
        quizID: "Quiz ID:",
        participants: "Participants:",
        updated: "Updated:",
        yourResults: "Your results",
        youAnswered: "You answered",
        outOf: "out of",
        questionsCorrectly: "questions correctly",
        passed: "PASSED",
        needsImprovement: "NEEDS IMPROVEMENT",
        quizQuestionsAnswers: "Quiz Questions & Answers",
        question: "Question",
        options: "Options:",
        correct: "Correct",
        incorrect: "Incorrect",
        correctAnswer: "Correct answer",
        yourAnswer: "Your answer",
        returnToQuizList: "Return to Quiz List",
        searchQuizIdPlaceholder: "Enter Quiz ID...",
        enterQuizIdError: "Please enter a Quiz ID",
        quizNotFoundError: "Quiz not found",
        searching: "Searching...",
        searchQuiz: "Search quizzes...",
        howToFindQuizId: "How to Find the Quiz ID",
        howToFindQuizIdDesc1: "The Quiz ID is a unique identifier for each quiz. It can be found in the quiz details or provided by the quiz creator.",
        howToFindQuizIdDesc2: "Or you can directly access the quiz by the link provided by the quiz creator.",
        quizDetails: "Quiz details",
        createdBy: "Created by",
        participantsLabel: "Participants",
        timeLimitLabel: "Time",
        numQuestionsLabel: "Questions",
        takeThisTest: "Take this test",
        transcription: "Content",
        copyText: "Copy text",
        dateLabel: "Date",
        descriptionLabel: "Description",
        contentLabel: "Transcription content",
        transcriptionNotFound: "Transcription not found",
        errorFetchingTranscription: "Unable to delete transcription",
        textCopied: "Text copied to clipboard!",
        copyFailed: "Failed to copy text",
        joiningClass: "Joining Class",
        joiningClassDescription: "Please wait while we join your class.",
        noJoinCodeProvided: "No join code provided",
        joinClassError: "Unable to join class",
        joinClassFailed: "Failed to join class",
        backToDashboard: "Back to Dashboard",
        joinClassSuccess: "Class joined successfully!",
        redirectingToClass: "Redirecting to your class...",
        searchResources: "Search resources",
        noMatchingResources: "No matching resources found",
        noMatchingResourcesDesc: "Try modifying your search term or check back later.",
        loadingQuiz: "Loading Quiz",
        errorFetchingQuizStatus: "Error fetching quiz status",
        errorFetchingQuiz: "Error fetching quiz",
        errorFetchingProgress: "Error fetching progress",
        errorSubmittingQuiz: "Error submitting quiz",
        progressSaved: "Progress saved",
        errorSavingProgress: "Error saving progress",
        saving: "Saving...",
        saveProgress: "Save Progress",
        submitQuiz: "Submit Quiz",
        quizAlreadyCompleted: "Quiz Already Completed",
        quizAlreadyCompletedDescription: "You have already attempted this quiz. You can view your results or return to the dashboard.",
        goToDashboard: "Go To Dashboard",
        quizInstructions: "Quiz Instructions",
        beforeYouBegin: "Before you begin:",
        stableInternetConnection: "Ensure you have a stable internet connection.",
        cannotPauseQuiz: "You cannot pause the quiz once started.",
        answerAllQuestions: "Answer all questions to the best of your knowledge.",
        timerStartsOnConfirm: "The timer will start as soon as you confirm.",
        autoSaveInfo: "Your progress is automatically saved every 30 seconds.",
        quizInProgressNotice: "You have a quiz in progress. Your previous answers will be loaded.",
        newQuizAttemptNotice: "This is a new quiz attempt.",
        understandStartQuiz: "I Understand, Start Quiz",
        questionsAnswered: "{{answered}} of {{total}} questions answered",
        ofTotal:"of",
        percentComplete: "{{percent}}% complete",
        previous: "Previous",
        next: "Next",
        timeRemaining: "Time Remaining",
        elapsedTime: "Elapsed Time",
        quizDetailsCopied:"Quiz details copied to clipboard!",
        checkoutQuiz:"Check out this quiz!",
        quizLink:"Quiz link:",
        numberQuestions:"Number of questions:",
        share:"Share",
        search:"Search",
        firstNameRequired:"The first name is required",
        lastNameRequired:"The last name is required",
        invalidEmail:"Invalid Email",
        signInSuccess:"Successfully signed in!",
        createAccount:"Create account",
        connexion:"Connexion",
        passwordRecommendations:"Recomanded : uppercases, lowercases, nummber & special characters",
        alreadySignedConnexion:"Already signed in? Connexion",
        noAccountSignIn:"No account? Sign in",
        signIn:"Sign in",
        signUp:"Sign up",
        password:"Password",
        email:"Email",
        lastName:"Last name",
        firstName:"First name"
    },
    fr: {
        dashboard: "Tableau de bord",
        classroom: "Classes",
        takeTest: "Passer un QCM",
        myResults: "Mes résultats",
        logout: "Déconnexion",
        hello: "Salut",
        user: "Utilisateur",
        classroomDescription: "Accédez à vos classes et supports de cours",
        testDescription: "Passez des QCM et évaluations",
        resultsDescription: "Consultez vos résultats et performances",
        confirmLogout: "Êtes-vous sûr de vouloir vous déconnecter ?",
        logoutMessage: "Vous êtes sur le point de vous déconnecter. Toutes les modifications non enregistrées seront perdues.",
        cancel: "Annuler",
        classDetails: "Détails de la classe",
        aboutThisClass: "À propos de cette classe",
        noDescription: "Aucune description disponible pour cette classe.",
        created: "Créé le :",
        availableResources: "Ressources disponibles",
        noResources: "Aucune ressource pour l'instant",
        noResourcesDescription: "Il n'y a pas encore de ressources disponibles pour cette classe.",
        continueQuiz: "Continuer le QCM",
        takeQuiz: "Passer le QCM",
        viewResults: "Voir les résultats",
        viewCourse: "Voir le cours",
        completed: "Terminé",
        inProgress: "En cours",
        pendingEvaluation: "En attente d'évaluation",
        notStarted: "Non commencé",
        errorLoading: "Erreur de chargement:",
        errorLoadingDescription: "Nous n'avons pas pu charger les détails de la classe. Veuillez réessayer plus tard.",
        backToClasses: "Retour aux classes",
        myClasses: "Mes Classes",
        calendar: "Calendrier",
        courses: "Cours",
        exam: "Examen",
        eventsFor: "Événements pour le",
        noEvents: "Aucun événement pour cette date",
        yourClasses: "Vos Classes",
        joinClass: "Rejoindre une classe",
        joinClassTitle: "Rejoindre une classe",
        joinCodePrompt: "Saisir le code de la classe",
        joinCodeLabel: "Code de classe",
        noMatchingClasses: "Aucune classe correspondante trouvée",
        noMatchingClassesDesc: "Essayez de modifier votre terme de recherche ou rejoignez une nouvelle classe.",
        noClassesAvailable: "Aucune classe pour l'instant",
        noClassesAvailableDesc: "Rejoignez une classe pour commencer.",
        joinSuccess: "Classe rejoint avec succès !",
        joinError: "Impossible de rejoindre la classe",
        searchPlaceholder: "Rechercher des classes...",
        yourQuizResults: "Vos résultats de QCM",
        noDescriptionGeneric: "Aucune description disponible",
        scoreLabel: "Score :",
        viewDetails: "Détails",
        noMatchingResults: "Aucun résultat correspondant trouvé",
        noMatchingResultsDesc: "Essayez de modifier votre terme de recherche ou passez un QCM pour voir les résultats ici.",
        noQuizResultsAvailable: "Aucun résultat de QCM disponible",
        noQuizResultsAvailableDesc: "Passez un QCM pour commencer à voir vos résultats ici.",
        quizResults: "Résultats du quiz",
        back: "Retour",
        errorLoadingQuiz: "Erreur de chargement des détails du QCM",
        goBack: "Retour",
        quizInformation: "Détails du QCM",
        timeLimit: "Limite de temps :",
        minutes: "min",
        quizID: "ID du QCM :",
        participants: "Participants :",
        updated: "Mis à jour :",
        yourResults: "Vos résultats",
        youAnswered: "Vous avez répondu à",
        outOf: "sur",
        questionsCorrectly: "questions correctement",
        passed: "RÉUSSI",
        needsImprovement: "DOIT S'AMÉLIORER",
        quizQuestionsAnswers: "Questions & Réponses",
        question: "Question",
        options: "Options :",
        correct: "Correct",
        incorrect: "Incorrect",
        correctAnswer: "Bonne réponse",
        yourAnswer: "Votre réponse",
        returnToQuizList: "Retour à la liste des QCM",
        searchQuizIdPlaceholder: "Entrez l'ID du QCM...",
        enterQuizIdError: "Veuillez entrer un ID de QCM",
        quizNotFoundError: "QCM introuvable",
        searching: "Recherche en cours...",
        searchQuiz: "Rechercher un QCM...",
        howToFindQuizId: "Comment trouver l'ID de QCM",
        howToFindQuizIdDesc1: "L'ID de QCM est un identifiant unique pour chaque QCM. Il peut être trouvé dans les détails du QCM ou fourni par le créateur.",
        howToFindQuizIdDesc2: "Ou vous pouvez accéder directement au QCM via le lien fourni par le créateur.",
        quizDetails: "Détails du QCM",
        createdBy: "Créé par",
        participantsLabel: "Participants",
        timeLimitLabel: "Temps",
        numQuestionsLabel: "Questions",
        takeThisTest: "Passer ce test",
        transcription: "Contenu",
        copyText: "Copier le texte",
        dateLabel: "Date",
        descriptionLabel: "Description",
        contentLabel: "Contenu de la transcription",
        transcriptionNotFound: "Transcription introuvable",
        errorFetchingTranscription: "Impossible de supprimer la transcription",
        textCopied: "Texte copié !",
        copyFailed: "Échec de la copie",
        joiningClass: "Connexion à la classe",
        joiningClassDescription: "Veuillez patienter pendant la connexion à votre classe.",
        noJoinCodeProvided: "Aucun code de classe fourni",
        joinClassError: "Impossible de rejoindre la classe",
        joinClassFailed: "Échec de la jonction à la classe",
        backToDashboard: "Retour au tableau de bord",
        joinClassSuccess: "Classe rejoint avec succès !",
        redirectingToClass: "Redirection vers votre classe...",
        searchResources: "Rechercher des ressources",
        noMatchingResources: "Aucune ressource correspondante trouvée",
        noMatchingResourcesDesc: "Essayez de modifier votre terme de recherche ou revenez plus tard.",
        loadingQuiz: "Chargement du QCM",
        errorFetchingQuizStatus: "Erreur lors de la récupération du statut du QCM",
        errorFetchingQuiz: "Erreur lors de la récupération du QCM",
        errorFetchingProgress: "Erreur lors de la récupération de la progression",
        errorSubmittingQuiz: "Erreur lors de la soumission du QCM",
        progressSaved: "Progression enregistrée",
        errorSavingProgress: "Erreur lors de l'enregistrement de la progression",
        saving: "Enregistrement en cours...",
        saveProgress: "Enregistrer la progression",
        submitQuiz: "Soumettre le QCM",
        quizAlreadyCompleted: "QCM déjà terminé",
        quizAlreadyCompletedDescription: "Vous avez déjà tenté ce QCM. Vous pouvez consulter vos résultats ou revenir au tableau de bord.",
        goToDashboard: "Aller au tableau de bord",
        quizInstructions: "Instructions du QCM",
        beforeYouBegin: "Avant de commencer :",
        stableInternetConnection: "Assurez-vous d'avoir une connexion internet stable.",
        cannotPauseQuiz: "Vous ne pouvez pas mettre le QCM en pause une fois commencé.",
        answerAllQuestions: "Répondez à toutes les questions du mieux que vous pouvez.",
        timerStartsOnConfirm: "Le chronomètre démarrera dès que vous confirmerez.",
        autoSaveInfo: "Votre progression est automatiquement enregistrée toutes les 30 secondes.",
        quizInProgressNotice: "Vous avez un QCM en cours. Vos réponses précédentes seront chargées.",
        newQuizAttemptNotice: "Il s'agit d'une nouvelle tentative de QCM.",
        understandStartQuiz: "J'ai compris, démarrer le QCM",
        questionsAnswered: "{{answered}} parmis {{total}} questions répondues",
        ofTotal:"parmis",
        percentComplete: "{{percent}}% terminés",
        previous: "Précédent",
        next: "Suivant",
        timeRemaining: "Temps restant",
        elapsedTime: "Temps écoulé",
        quizDetailsCopied:"Les détails du quiz ont été copiés dans le pressepapier.",
        checkoutQuiz:"Jetez un œil à ce quiz !",
        quizLink:"Liens vers le quiz :",
        numberQuestions:"Nombre de questions :",
        share:"Partager",
        search:"Rechercher",
        firstNameRequired:"Le prénom est requis",
        lastNameRequired:"Le nom de famille est requis",
        invalidEmail:"Email invalide",
        signInSuccess:"Inscription réussie !",
        createAccount:"Créer un compte",
        connexion:"Connexion",
        passwordRecommandetions:"Recommandé : lettres majuscules, minuscules, chiffres & spéciaux",
        alreadySignedConnexion:"Déjà inscrit ? Connectez-vous",
        noAccountSignIn:"Pas de compte ? Inscrivez-vous",
        signIn:"S'enregistrer",
        signUp:"Se connecter",
        password:"Mot de passe",
        email:"Email",
        lastName:"Nom de famille",
        firstName:"Prénom"
    }
};